/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetArtistPagePublishingBooksQueryVariables = Exact<{
	filter?: Types.Publishing_Books_Filter | null | undefined;
	limit?: number | null | undefined;
	offset?: number | null | undefined;
	sort?: Array<string | null | undefined> | string | null | undefined;
}>;

export type GetArtistPagePublishingBooksQuery = {
	Publishing_Books_aggregated: Array<{
		countDistinct: { id: number | null } | null;
	}>;
	Publishing_Books: Array<{
		id: string;
		slug: string | null;
		title: string | null;
		exclusive: boolean;
		artist_name_override: string | null;
		show_author_artist: string | null;
		show_all_bios: boolean | null;
		series: {
			id: string;
			only_show_preview_in_gallery: boolean | null;
			title: string | null;
			option_label: string | null;
			minBooks: Array<{
				product: {
					price: number;
					sale_price: number | null;
					sku: string;
					can_pre_order: boolean;
				} | null;
			} | null> | null;
			maxBooks: Array<{
				product: {
					price: number;
					sale_price: number | null;
					sku: string;
					can_pre_order: boolean;
				} | null;
			} | null> | null;
			inStock: Array<{ product: { id: string } | null } | null> | null;
		} | null;
		product: {
			id: string;
			price: number;
			sale_price: number | null;
			currency: string;
			sku: string;
			in_stock: boolean | null;
			can_pre_order: boolean;
		} | null;
		authors: Array<{
			Publishing_Authors_And_Artists_id: {
				id: string;
				full_name: string | null;
			} | null;
		} | null> | null;
		artists: Array<{
			Publishing_Authors_And_Artists_id: { full_name: string | null } | null;
		} | null> | null;
		featured_image: {
			filename_disk: string | null;
			width: number | null;
			height: number | null;
		} | null;
	}>;
};

export const GetArtistPagePublishingBooksDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'getArtistPagePublishingBooks' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'filter' },
					},
					type: {
						kind: 'NamedType',
						name: { kind: 'Name', value: 'Publishing_Books_filter' },
					},
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'limit' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: {
						kind: 'Variable',
						name: { kind: 'Name', value: 'offset' },
					},
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
					type: {
						kind: 'ListType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'String' },
						},
					},
				},
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Publishing_Books_aggregated' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'filter' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'countDistinct' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'Publishing_Books' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'filter' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'limit' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'limit' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'offset' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'offset' },
								},
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sort' },
								value: {
									kind: 'Variable',
									name: { kind: 'Name', value: 'sort' },
								},
							},
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'BookGridItemWithSeries' },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'ImageWithDimensions' },
			typeCondition: {
				kind: 'NamedType',
				name: { kind: 'Name', value: 'directus_files' },
			},
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'filename_disk' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'width' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'height' } },
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BookGridItem' },
			typeCondition: {
				kind: 'NamedType',
				name: { kind: 'Name', value: 'Publishing_Books' },
			},
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'slug' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
					{ kind: 'Field', name: { kind: 'Name', value: 'exclusive' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'artist_name_override' },
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'show_author_artist' },
					},
					{ kind: 'Field', name: { kind: 'Name', value: 'show_all_bios' } },
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'product' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'price' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'sale_price' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'currency' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'sku' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'in_stock' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'can_pre_order' },
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'authors' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: {
										kind: 'Name',
										value: 'Publishing_Authors_And_Artists_id',
									},
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'full_name' },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'artists' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: {
										kind: 'Name',
										value: 'Publishing_Authors_And_Artists_id',
									},
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'full_name' },
											},
										],
									},
								},
							],
						},
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'featured_image' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'FragmentSpread',
									name: { kind: 'Name', value: 'ImageWithDimensions' },
								},
							],
						},
					},
				],
			},
		},
		{
			kind: 'FragmentDefinition',
			name: { kind: 'Name', value: 'BookGridItemWithSeries' },
			typeCondition: {
				kind: 'NamedType',
				name: { kind: 'Name', value: 'Publishing_Books' },
			},
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'FragmentSpread',
						name: { kind: 'Name', value: 'BookGridItem' },
					},
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'series' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'only_show_preview_in_gallery' },
								},
								{ kind: 'Field', name: { kind: 'Name', value: 'title' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'option_label' },
								},
								{
									kind: 'Field',
									alias: { kind: 'Name', value: 'minBooks' },
									name: { kind: 'Name', value: 'books' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'limit' },
											value: { kind: 'IntValue', value: '1' },
										},
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'sort' },
											value: {
												kind: 'ListValue',
												values: [
													{
														kind: 'StringValue',
														value: 'product.sale_price',
														block: false,
													},
													{
														kind: 'StringValue',
														value: 'product.price',
														block: false,
													},
												],
											},
										},
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'filter' },
											value: {
												kind: 'ObjectValue',
												fields: [
													{
														kind: 'ObjectField',
														name: { kind: 'Name', value: 'product' },
														value: {
															kind: 'ObjectValue',
															fields: [
																{
																	kind: 'ObjectField',
																	name: { kind: 'Name', value: 'price' },
																	value: {
																		kind: 'ObjectValue',
																		fields: [
																			{
																				kind: 'ObjectField',
																				name: { kind: 'Name', value: '_gt' },
																				value: { kind: 'IntValue', value: '0' },
																			},
																		],
																	},
																},
															],
														},
													},
												],
											},
										},
									],
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'product' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'price' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'sale_price' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'sku' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'can_pre_order' },
														},
													],
												},
											},
										],
									},
								},
								{
									kind: 'Field',
									alias: { kind: 'Name', value: 'maxBooks' },
									name: { kind: 'Name', value: 'books' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'limit' },
											value: { kind: 'IntValue', value: '1' },
										},
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'sort' },
											value: {
												kind: 'ListValue',
												values: [
													{
														kind: 'StringValue',
														value: '-product.sale_price',
														block: false,
													},
													{
														kind: 'StringValue',
														value: '-product.price',
														block: false,
													},
												],
											},
										},
									],
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'product' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'price' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'sale_price' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'sku' },
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'can_pre_order' },
														},
													],
												},
											},
										],
									},
								},
								{
									kind: 'Field',
									alias: { kind: 'Name', value: 'inStock' },
									name: { kind: 'Name', value: 'books' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'product' },
												arguments: [
													{
														kind: 'Argument',
														name: { kind: 'Name', value: 'filter' },
														value: {
															kind: 'ObjectValue',
															fields: [
																{
																	kind: 'ObjectField',
																	name: { kind: 'Name', value: 'in_stock' },
																	value: {
																		kind: 'ObjectValue',
																		fields: [
																			{
																				kind: 'ObjectField',
																				name: { kind: 'Name', value: '_eq' },
																				value: {
																					kind: 'BooleanValue',
																					value: true,
																				},
																			},
																		],
																	},
																},
															],
														},
													},
												],
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'id' },
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetArtistPagePublishingBooksQuery,
	GetArtistPagePublishingBooksQueryVariables
>;
